import type { ReactElement } from 'react'
import './TitleToast.css'

interface TitleToastProps {
  message: string | null
  /** Inverted color scheme for the twilight variant (cream-on-dark). */
  tone?: 'paper' | 'twilight'
}

/** One-line, auto-dismissing soft-disable banner shown when a feature
 *  isn't wired yet (Lobby / Join with Code). Lives in the top-center
 *  of the title surface. */
export function TitleToast({ message, tone = 'paper' }: TitleToastProps): ReactElement {
  const visible = message !== null
  return (
    <div
      className={`title-toast title-toast--${tone}${visible ? ' title-toast--visible' : ''}`}
      role="status"
      aria-live="polite"
    >
      <span className="title-toast__dot" aria-hidden="true">·</span>
      <span className="title-toast__msg">{message ?? ''}</span>
    </div>
  )
}
